import useDialog from "@hooks/useDialog";
import React from "react";
import ReactPlayer from "react-player";
import { BsPlayCircleFill } from "react-icons/bs";
import { cn } from "@utils/index";

export default function VideoPreview({
    children,
    videoUrl,
    className,
}: {
    children: React.ReactNode;
    videoUrl: string;
    className?: string
}) {
    const { openDialog } = useDialog();

    return (
        <div
            className="group relative w-full h-full items-center justify-center"
        >
            {children}
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    openDialog({
                        showActions: false,
                        maxWidth: "80vw",
                        height: "90vh",
                        disableBG: true,
                        customContent: (
                            <div className="flex h-full w-full items-center justify-center p-0">
                                <ReactPlayer
                                    url={videoUrl}
                                    controls
                                    width="100%"
                                    height="100%"
                                    playing
                                />
                            </div>
                        ),
                    });
                }}
                className={cn("absolute size-4 inset-0 flex items-center justify-center bg-black/30 opacity-0 transition-opacity group-hover:opacity-100", className)}
            >
                <BsPlayCircleFill className="text-2xl text-white" />
            </button>
        </div>
    );
}